import Tile from "./TileBonusGame";
export default Tile;
